export default [
  'fetch_lessons@list',
  'fetch_lesson@single',
];
